import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { App } from "./App";
import { AppProvider } from "./store";
import "./styles.css";

/**
 * Hash routing on purpose: the app is served as static files in the PoC, and the payment provider's
 * redirect URLs point back into it, so there must be no dependency on server-side rewrite rules.
 */
ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <HashRouter>
      <AppProvider>
        <App />
      </AppProvider>
    </HashRouter>
  </React.StrictMode>
);
